import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, ButtonGroup } from '@mui/material';
import {
    Grid,
    Divider,
    Alert
} from '@mui/material';
import CreateForms from '../../organismos/forms';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { carCaseActionsSaga } from '../../../../infrastructure/services/carCase';
import { carCaseActions } from '../../../../application/actions/carCase';

import entity from './entity';
import moment from 'moment';
import GradientCircularLoader from '../circularLoader/circularLoader';


export default function CreateGarmentCar({
    data,
    handlerShow,
    handlerCallBack,
    show,
    title
}) {
    const dispatch = useDispatch();
    const [disabled, setDisabled] = useState(true)
    const [caseToSend, setCaseToSend] = useState({})
    const { data: dataGetById } = useSelector((store) => store.tk.carCase.getById);
    const { connection:connectionCreate, result:resultCreate  } = useSelector((store) => store.tk.carCase.create);
    const { connection:connectionUpdate, result:resultUpdate  } = useSelector((store) => store.tk.carCase.update);



    const handlerFindCase = (caseId, stateId) => {
        dispatch(carCaseActionsSaga.getById({ id: data.idcase }))
    }

    useEffect(() => {
        console.log(data)
        data !== null && handlerFindCase()
    }, [data])



    const handlerChange = () => {
        if (data) {
            console.log('A,', caseToSend)
            dispatch(carCaseActionsSaga.update({id: data.idcase, data: caseToSend}))
        } else {
            console.log('B,', caseToSend)
            dispatch(carCaseActionsSaga.create(caseToSend))
        }
    }

    const getFieldsPay = (fields) => {
        const update = {}
        fields.map((F) => F.groups.map(G => {
            // console.log(G)
            if (!G.optional) {
                update[G.id] = {}
                //console.log(G.id)
                G.fields.map(F => {
                    //console.log([F.id] , F.value)
                    F.value !== undefined &&
                    F.id !== "idPersonType" &&
                    F.id !== "idPersonType1" &&
                    F.id !== "idPersonType2" && F.kind === 'date' ?  (update[G.id][F.id] = moment(F.value).format('YYYY-MM-DD')):(update[G.id][F.id] = F.value)
                })
            } else if (G.optional && !G.optionalHideDefauld) {
                update[G.id] = {}
                G.fields.map(F => {
                    //console.log([F.id] , F.value)
                    F.value !== undefined &&
                    F.id !== "idPersonType" &&
                    F.id !== "idPersonType1" &&
                    F.id !== "idPersonType2" && F.kind === 'date' ?  (update[G.id][F.id] = moment(F.value).format('YYYY-MM-DD')):(update[G.id][F.id] = F.value)
                })

            }
        }))
        //console.log(update)
        setCaseToSend({ data: update });
    }

    const getEnableFieldsPay = (flag) => {
        console.log(flag)
        setDisabled(flag)
    }

    /**FIND ENTITYS FOR CLIENT ID */

    const { data: location } = useSelector((store) => store.tk.globalData.location)
    const { data: getAllClient } = useSelector((store) => store.tk.client.getAll);
    console.log(entity.formulario)
    const formulario = entity.formulario.find(item => item.name === (data? 'edit':'create'))?.form(getAllClient, location.region, location.comuna);
    console.log(formulario)

    const handlerExit = () => {
        dispatch(carCaseActions.getByIdReset())
        dispatch(carCaseActions.createReset())
        dispatch(carCaseActions.updateReset())
        handlerShow()
    }

    useEffect(()=>{
        handlerCallBack();
        (resultCreate || resultUpdate) && handlerExit();
    },[resultCreate, resultUpdate])

    return (

        <Dialog
            disableEscapeKeyDown
            open={show}
            onClose={() => handlerExit()}
            fullWidth={'lg'}
            maxWidth={'lg'}
        >
            <DialogTitle sx={{ lineHeight: 1.2 }}>
                <Typography sx={{ pb: 0, mb: 0 }} variant="h5" component="p">{data ? title : 'INGRESO DE DEMANDAS'}</Typography>
            </DialogTitle>
            <Divider variant="" />
            <DialogContent sx={{ p: 0 }}>
            {(connectionCreate || connectionUpdate) && <Box sx={{ backgroundColor: '#ffffff99', position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, zIndex: 100, textAlign: 'center', paddingTop: '35%' }}><GradientCircularLoader /></Box>}

                <Grid container>

                    <Grid sx={{ p: 0 }} xs={12} sm={12} md={12}>

                        {formulario && 
                            <CreateForms
                                fields={formulario}
                                getFields={getFieldsPay}
                                getEnabledForm={getEnableFieldsPay}
                                sxfields={{ mt: 2 }}
                                dataDefauld={dataGetById}
                            />}
                    </Grid>
                </Grid>
            </DialogContent>
            <Divider variant="" />
            <DialogActions>
                <ButtonGroup sx={{ pt: 0 }} fullWidth variant="contained" >
                    <Button disabled={!disabled} color="success" onClick={() => { handlerChange(); }}>
                        {data ? 'actualizar' : 'crear'}
                    </Button>
                    <Button onClick={() => { handlerExit(); }}>
                        Salir
                    </Button>
                </ButtonGroup>
            </DialogActions>
        </Dialog>


    );
}